import {
  allMetrics as metrics,
  metricToDisplayNameMap,
  defaultGridColumns,
} from '@bingads-webui-campaign/overview-cards-common';

export const getTablePropsFromPreferenceForDevices = ({
  cardPreference,
  patchPreference,
  permissions,
  navigationLevel,
  campaignType,
  i18n,
}) => {
  const selectedColumns = (cardPreference && cardPreference.selectedColumns) || defaultGridColumns;
  const allMetrics = metrics(permissions, 1, campaignType).map(metric => ({
    key: metric,
    displayName: i18n.getString(metricToDisplayNameMap[metric]),
  }));
  const initialSelectedMetrics = selectedColumns.map(column => allMetrics.find(metric => metric.key === column));

  return {
    initialSelectedMetrics,
    allMetrics,
    patchPreference,
    navigationLevel,
    campaignType,
  };
};

export const isDevicePreferenceValid = ({
  cardPreference,
  permissions,
  campaignType,
}) => {
  const metricsKeys = metrics(permissions, 1, campaignType);
  if (!cardPreference
    || cardPreference.selectedColumns.length !== 3
    || cardPreference.selectedColumns.some(column => !metricsKeys.includes(column))
  ) {
    return false;
  }

  return true;
};

export const getDefaultDevicePreference = () => ({
  selectedColumns: defaultGridColumns,
});
